module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "kpi-card",
    class: 'is-' + _vm.level
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm._t("default", function() {
    return [_c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(_vm.value)), (_vm.unit && _vm.value !== '—') ? _c('span', {
      staticClass: "kpi-unit"
    }, [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])]
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), (_vm.compare) ? _c('span', {
    staticClass: "kpi-compare",
    class: 'is-' + _vm.compareTone
  }, [_vm._v(_vm._s(_vm.compare))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v(_vm._s(_vm.foot))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59518f3c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/parts/KpiCard.vue
// module id = 1829
// module chunks = 8